var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { css: false },
      on: {
        enter: _vm.enter,
        leave: _vm.leave,
        "enter-cancelled": _vm.enterCancelled,
        "leave-cancelled": _vm.leaveCancelled,
      },
    },
    [
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          staticClass: "pageTopBtn",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.scroll.apply(null, arguments)
            },
          },
        },
        [_c("i", { staticClass: "bi bi-chevron-double-up fz_18 fz_md_22" })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }